import React from 'react';

const DOWNLOAD_URL = 'https://github.com/foxsamuel-pro/amonglr/releases/latest/download/AmongLR-Setup.exe';

export default function DownloadPage() {
  return (
    <div className="download-page">
      <div className="download-hero">
        <h1 className="download-title">AmongLR Desktop App</h1>
        <p className="download-subtitle">
          The ultimate Among Us companion — track your ELO, view stats, and get real-time overlays while you play.
        </p>
      </div>

      <div className="download-cta">
        <a
          href={DOWNLOAD_URL}
          className="download-button"
          download="AmongLR-Setup.exe"
        >
          Download for Windows
        </a>
        <p className="download-requirements">Windows 10 or later required</p>
      </div>

      <div className="download-features">
        <h2 className="download-section-title">Features</h2>
        <div className="download-feature-grid">
          <div className="download-feature">
            <span className="download-feature-icon">📊</span>
            <h3>Live Overlay</h3>
            <p>See your ELO, tokens, and win/loss stats in a sleek overlay while playing Among Us.</p>
          </div>
          <div className="download-feature">
            <span className="download-feature-icon">🏆</span>
            <h3>Post-Game Results</h3>
            <p>Animated ELO change breakdown for you and every player after each game.</p>
          </div>
          <div className="download-feature">
            <span className="download-feature-icon">🚀</span>
            <h3>Quick Launch</h3>
            <p>Launch Among Us directly from the app — no need to switch to Steam.</p>
          </div>
          <div className="download-feature">
            <span className="download-feature-icon">🌐</span>
            <h3>Full Website Access</h3>
            <p>Browse the leaderboard, open lootboxes, play casino games, and trade on the marketplace — all built in.</p>
          </div>
        </div>
      </div>

      <div className="download-install">
        <h2 className="download-section-title">Installation</h2>
        <ol className="download-steps">
          <li>Download the installer above</li>
          <li>Run <strong>AmongLR-Setup.exe</strong></li>
          <li>Sign in with your AmongLR account</li>
          <li>Launch Among Us from the app and play!</li>
        </ol>
      </div>
    </div>
  );
}
